<template>
    <div>
      <v-card class="rounded-lg pa-6" elevation="0">  
        <template>
            <v-data-table
            :disabled="disableTable"
            :footer-props="{'items-per-page-text': 'Perfis por Página',}"
            :headers="headers"
            :items="abilities"
            item-value="id"
            :selectable="true"
            :single-select="false"
            v-model="selectedItems"
            show-select
            class="elevation-1"
            >
            <template v-slot:top>
                <v-toolbar flat>
                <v-toolbar-title>Lista de Habilidades: {{ profileName }}</v-toolbar-title>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-checkbox v-model="selectedItems" :value="item"></v-checkbox>
            </template>
            </v-data-table>
        </template>
        <br>
        <v-row>
            <v-btn color="#41916b" dark class="rounded-lg" @click="saveAbilities()" :loading="loading" style="margin-right: 10px; margin-left: 10px">{{$t('buttons.save')}}</v-btn>
            <v-btn color="white" class="rounded-lg" @click="$router.push('/perfis')">{{$t('buttons.return')}}</v-btn>
        </v-row>
      </v-card>

      <v-snackbar absolute background-color="white" color="#104a21" v-model="snackbar">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                Fechar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
import { getAbilities, saveAbilities } from "@/service/basic-registrations/ProfileService";
import { mapActions } from "vuex";
  export default {
    data() {
      return {
        headers: [
          { text: 'Habilidades', align: 'start', sortable: false, value: 'name' },
          { text: 'Slug', value: 'slug' },
        ], 
        profileName:"",
        selectedItems: [],
        selectedItemsId: [],
        abilities: [],
        snackbar: false,
        message: "",
        disableTable: true,
        loading: false
      };
    },

    async created() {
        this.profileName = this.$route.query.item.name
        await this.loadAbilities();

        this.$nextTick(() => {
            this.fillAbilities();
        });
    }, 

    methods: {
        ...mapActions([
            "changeSnackBarData", 
        ]),

        loadAbilities(){
            return getAbilities().then((result) => {
                this.abilities = result;
            });
        },

        saveAbilities(){
            this.loading = true;

            let abilities = this.selectedItems.map((item) => item.id)
            let id = this.$route.query.item.id

            const data = {
                abilities: abilities
            }

            saveAbilities(id, data).then((response) => {
                this.loading = false;
                this.changeSnackBarData({
                    status: true,
                    type: 'success', 
                    titleMessage: response.data.message,
                    bodyMessage: '',
                    cardColor: 'success',
                    titleIcon: 'mdi-check-circle',
                }); 

                setTimeout(() => { 
                    this.$router.push('/perfis')
                    this.closeSnackBar();
                }, 3000);
            }).catch((error) => {
                this.loading = false;
                this.changeSnackBarData({
                    status: true,
                    type: 'erro', 
                    titleMessage: this.$t('messages.something_went_wrong'),
                    bodyMessage: error.error,
                    cardColor: 'red',
                    titleIcon: 'mdi-close-circle',
                });

                setTimeout(() => {
                    this.closeSnackBar();
                }, 3000);
            });
        },
 
        fillAbilities() {
            const abilityIds = this.$route.query.item.abilities.map(
                (item) => parseInt(item.pivot.ability_id)
            );

            // só adiciona os que realmente existem na tabela
            this.selectedItems = this.abilities.filter((a) =>
                abilityIds.includes(a.id)
            );
        },

        closeSnackBar(){
            this.changeSnackBarData({
                status: false,
                type: '', 
                titleMessage: '',
                bodyMessage: '',
                cardColor: '',
                titleIcon: '',
            });
        }

    }
  };
  </script>
  